import React from "react";
import { FormikProps } from "formik";
import { LoginFormInitialValues } from "./LoginFormWrapper";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMPassword from "src/components/UI/atoms/formFields/ATMPassword/ATMPassword";
import { LOGIN_PAGE_NAME, LOGIN_PAGE_TAGLINE } from "src/utils/constants";

type Props = {
  formikProps: FormikProps<LoginFormInitialValues>;
  isInvalidPassword: boolean;
};

const LoginForm = ({ formikProps, isInvalidPassword }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className="flex flex-col md:grid grid-cols-2 h-screen bg-white justify-center items-center p-4">
      <div className="p-16 flex flex-col gap-10 w-full h-full items-center justify-center">
        <div className="flex flex-col gap-6 w-1/2">
          {/* TEXT */}
          <div className="flex flex-col">
            <p className="italic text-md">Welcome!</p>
            <p className="text-2xl font-medium">Login in {LOGIN_PAGE_NAME}</p>
            <p className="text-md font-regular pt-4">{LOGIN_PAGE_TAGLINE}</p>
          </div>
        </div>
        {/* INPUT FIELDS */}
        <div className="flex flex-col gap-8 w-1/2">
          <div className="flex flex-col gap-6">
            {/* Email */}
            <div className="">
              <ATMTextField
                name="email"
                required
                value={values.email}
                onChange={(e) => setFieldValue("email", e.target.value)}
                label="Email"
                placeholder="Enter Email"
                onBlur={handleBlur}
              />
            </div>

            {/* Password */}
            <div className="">
              <ATMPassword
                name="password"
                required
                value={values.password}
                onChange={(e) => setFieldValue("password", e.target.value)}
                label="Password"
                placeholder="Enter Password"
                onBlur={handleBlur}
                extraClasses={`${isInvalidPassword ? "shake-horizontal" : ""}`}
              />
            </div>
          </div>

          {/* BUTTON */}
          <ATMLoadingButton isLoading={isSubmitting} type="submit">
            Login
          </ATMLoadingButton>
        </div>
      </div>
      <div className="flex items-center justify-center h-full bg-login rounded-sm">
        <div className="flex flex-col gap-4 p-8 text-white justify-between h-full">
          <div className="flex  items-center gap-4">
            <div className="size-14 p-2 bg-gray-50 rounded-sm">
              <img className="" src="./logo192.png" alt="logo" />
            </div>
            <p className="text-2xl font-semibold">{LOGIN_PAGE_NAME}</p>
          </div>
          <div className=" flex flex-col gap-3">
            <p className="text-5xl">Centralized Business Management Hub</p>
            <p className="text-md">
              Streamline all your operations, from finances to customer
              interactions, in one convenient platform. Simplify your workflow,
              increase efficiency, and stay organized with our comprehensive
              solution.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
